/**
 * Shared 복습한-표현 count, so the global header can show a real rank.
 *
 * WHY A STORE: HeaderLoggedIn is mounted in App.vue, outside the home panel, so
 * it cannot reach the panel's derived band counts. It had `rankFor(0)`
 * hardcoded with a comment explaining that 0 was honest pre-Phase-C — the third
 * place that pattern appeared (the bar and the ⓘ panel were the others). The
 * comment was true when written and became false the moment the drill shipped,
 * so every member has been Lv.1 스태프 regardless of what they actually earned.
 *
 * Mirrors certifiedStore, which solves the same problem for the 🔥 counter.
 */
import { reactive } from 'vue';

const state = reactive({ mastered: 0, known: false });

/** Publish the count. Called by whoever derives it from expressionState. */
export function setMastered(n) {
  state.mastered = Math.max(0, Number(n) || 0);
  state.known = true;
}

/**
 * Read the count. `known` distinguishes "genuinely 0" from "not loaded yet" —
 * the header shows Lv.1 either way, but a caller that needs to avoid
 * flashing a wrong rank can wait for it.
 */
export function masteredCount() {
  return state.mastered;
}

export function masteredKnown() {
  return state.known;
}

export const masteredState = state;
